"use strict";

import $ from 'jquery';
import animationsUtility from './utility/animations.js';
import customCursor from './modules/custom-cursor.mjs';
import menu from './modules/menu.mjs';
import magnificPopup from './modules/magnific-popup.mjs';
import loading from './modules/loading.mjs';
import animations from './modules/animations.mjs';
import utilities from "./utility/utilities.js";
import pageTransitions from './modules/page-transitions.mjs';
import logo from './modules/logo.mjs';
import newsletterBloc from './modules/newsletter-bloc.mjs';
import footerToTop from './modules/footer-to-top.mjs';
import scrollingKeywords from './modules/scrolling-keywords.mjs';
import scrollingCustomers from './modules/scrolling-customers.mjs';
import headingAnimation from './modules/heading-animation.mjs';
import servicesList from './modules/services-list.mjs';
import projectsList from './modules/projects-list.mjs';
import projectHeader from './modules/project-header.mjs';
import projectsTags from './modules/project-tags.mjs';
import projectContentGrid from './modules/project-content-grid.mjs';
import projectPagination from './modules/project-pagination.mjs';
import collaboratorsGrid from './modules/collaborators-grid.mjs';
import contactForm from './modules/contact-form.mjs';
import socialShare from './modules/social-share.mjs';
import blogArticlesList from './modules/blog-articles-list.mjs';
import videoPlayer from './modules/video-player.mjs';
import mailtoInterceptor from './modules/mailto-interceptor.mjs';
import alpineManager from './modules/alpine-manager.mjs';
import tcNeosElementsBootstrap from 'tc-neos-elements-bootstrap';
import tcNeosElements from 'tc-neos-elements'; // do not remove this line, even if it is not used (Google Maps call initMap() from this file)

// Expose tcNeosElementsBootstrap globally for use in other modules
window.tcNeosElementsBootstrap = tcNeosElementsBootstrap;

$(document).ready(() => {
  setTimeout(() => {
    // Initialize Alpine.js first (this will load Jonnitto plugins)
    alpineManager.init()

    // Wait for Alpine.js to be ready before initializing other modules
    const waitForAlpine = () => {
      if (window.Alpine && alpineManager.isInitialized()) {
        initializeModules();
      } else {
        setTimeout(waitForAlpine, 50);
      }
    };

    const initializeModules = () => {
      animationsUtility.initGsap()
      utilities.init()
      loading.init()
      logo.animateHeaderLogo()
      menu.navActiveShortcuts()
      menu.initMegaMenu()
      newsletterBloc.init()
      footerToTop.init()
      headingAnimation.init()
      projectsList.init()
      servicesList.init()
      projectHeader.init()
      projectsTags.init()
      projectContentGrid.init()
      projectPagination.init()
      collaboratorsGrid.init()
      contactForm.init()
      socialShare.init()
      blogArticlesList.init()
      videoPlayer.init()
      mailtoInterceptor.init()

      tcNeosElementsBootstrap.anchor()
      window.addEventListener('hashchange', () => {
        tcNeosElementsBootstrap.anchor()
      })

      if (!$('body').hasClass('neos-backend')) {
        customCursor.init()
        magnificPopup.init()
        animations.init()
        pageTransitions.init()
        scrollingKeywords.init()
        scrollingCustomers.init()
      }
    };

    // Les callbacks Cloudflare Turnstile (window.cloudflareTurnstile*) sont désormais
    // définies en INLINE dans le <head>, avant api.js
    // (resource://TC.Website/Private/Fusion/NodeTypes/Document/Default/turnstile-callbacks.js).
    // Raison : api.js (async) peut appeler la callback avant l'exécution de ce bundle
    // (chargé en fin de <body>), ce qui faisait perdre le jeton -> « propriété obligatoire ».

    waitForAlpine();
  }, 10)
})
